/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useContext, useEffect, useState } from 'react';
import {
  Tree,
  getBackendOptions,
  MultiBackend,
  getDescendants,
} from '@minoru/react-dnd-treeview';
import { DndProvider } from 'react-dnd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import styles from '../gestione-sito-web/App.module.css';
import CustomNode from '../../../components/GestioneAmmTrasparenza/CustomNode';
import ModaleCreazioneNuovoElemento from '../../../components/GestioneAmmTrasparenza/ModaleCreazioneNuovoElemento';
import sitiWebService from '../../../services/sitiWebService';
import { Context } from '../../../utils/Context';
import TitlePage from '../../../components/GestisciUtenti/TitoloPagina';

const getLastId = (treeData) => {
  const reversedArray = [...treeData].sort((a, b) => {
    if (a.id < b.id) {
      return 1;
    } if (a.id > b.id) {
      return -1;
    }

    return 0;
  });

  if (reversedArray.length > 0) {
    return reversedArray[0].id;
  }

  return 0;
};

export default function App() {
  const [context, setContext] = useContext(Context);
  const [treeData, setTreeData] = useState([]);
  const [openModaleNuovoElemento, setOpenModaleNuovoElemento] = useState(false);
  // const [elementiEliminati, setElementiEliminati] = useState([]);

  function openCloseModaleAggiungiElemento() {
    setOpenModaleNuovoElemento(!openModaleNuovoElemento);
  }

  const handleDrop = (
    newTree,
    // {
    //   dragSourceId, dropTargetId, dragSource, dropTarget,
    // },
  ) => {
    // console.log(dragSourceId, dropTargetId, dragSource, dropTarget);

    // Do something
    setTreeData(newTree);
  };

  const handleCopy = (id) => {
    const lastId = getLastId(treeData);
    const targetNode = treeData.find((n) => n.id === id);
    const descendants = getDescendants(treeData, id);
    const partialTree = descendants.map((node) => ({
      ...node,
      id: node.id + lastId,
      parent: node.parent + lastId,
    }));

    setTreeData([
      ...treeData,
      {
        ...targetNode,
        id: targetNode.id + lastId,
      },
      ...partialTree,
    ]);
  };

  const handleSubmit = (newNode) => {
    const lastId = getLastId(treeData) + 1;

    setTreeData([
      ...treeData,
      {
        ...newNode,
        id: lastId,
      },
    ]);
    openCloseModaleAggiungiElemento();
  };

  const handleTextChange = (id, value) => {
    const newTree = treeData.map((node) => {
      if (node.id === id) {
        return {
          ...node,
          text: value,
        };
      }

      return node;
    });

    setTreeData(newTree);
  };

  const handleFlagObbligatorioChange = (id, value) => {
    const newTree = treeData.map((node) => {
      if (node.id === id) {
        return {
          ...node,
          flagObbligatorio: value,
        };
      }

      return node;
    });

    setTreeData(newTree);
  };

  const handleFlagDeprecatoChange = (id, value) => {
    const newTree = treeData.map((node) => {
      if (node.id === id) {
        return {
          ...node,
          flagDeprecato: value,
        };
      }

      return node;
    });

    setTreeData(newTree);
  };

  const handleFlagRappGrafica = (id, value) => {
    const newTree = treeData.map((node) => {
      if (node.id === id) {
        return {
          ...node,
          flagRappGrafica: value,
        };
      }

      return node;
    });

    setTreeData(newTree);
  };

  async function getAlbero() {
    try {
      const response = await sitiWebService.getAlberoAmmTrasparente();
      setTreeData(response);
    } catch (err) {
      setContext(() => ({
        ...context, open: true, testoErrore: err?.data?.message || 'Errore', statusCode: err?.status,
      }));
    }
  }

  async function upsertAlbero() {
    try {
      const response = await sitiWebService.upsertAlberoAmmTrasparente(treeData);
      setContext(() => ({
        ...context, openConferma: true, testo: response.message || 'Operazione eseguita correttamente',
      }));
      getAlbero();
    } catch (err) {
      setContext(() => ({
        ...context, open: true, testoErrore: err?.data?.message || 'Errore', statusCode: err?.status,
      }));
    }
  }

  useEffect(() => {
    getAlbero();
  }, []);

  return (
    <>
      <TitlePage
        title="Gestione albero Amministrazione trasparente"
        subtitle="È possibile gestire la struttura dell'amministrazione trasparente."
      />
      <DndProvider backend={MultiBackend} options={getBackendOptions()}>
        <Button onClick={openCloseModaleAggiungiElemento} className="m-2 text-uppercase">
          <FontAwesomeIcon aria-hidden="true" icon="plus" />
          AGGIUNGI ELEMENTO
        </Button>
        <Button onClick={upsertAlbero} className="m-2 float-end text-uppercase">
          <FontAwesomeIcon aria-hidden="true" icon="save" />
          SALVA
        </Button>
        <Tree
          classes={{
            root: styles.treeRoot,
            draggingSource: styles.draggingSource,
            dropTarget: styles.dropTarget,
          }}
          tree={treeData}
          rootId={0}
          onDrop={handleDrop}
          dragPreviewRender={(monitorProps) => {
            const { item } = monitorProps;

            return (
              <div>
                <p>{item.text}</p>
              </div>
            );
          }}
          render={(node, options) => (
            <CustomNode
              node={node}
              {...options}
              // onDelete={handleDelete}
              onCopy={handleCopy}
              onTextChange={handleTextChange}
              onFlagObbligatorioChange={handleFlagObbligatorioChange}
              onFlagDeprecatoChange={handleFlagDeprecatoChange}
              onFlagRappGraficaChange={handleFlagRappGrafica}
            />
          )}
        />
        {openModaleNuovoElemento && (
        <ModaleCreazioneNuovoElemento
          tree={treeData}
          onClose={openCloseModaleAggiungiElemento}
          onSubmit={handleSubmit}
          show={openModaleNuovoElemento}
        />
        )}
      </DndProvider>
    </>
  );
}
